__turbopack_context__.v({
  "select": "ttmSelect-module-scss-module__po_59q__select",
});
